import { motion } from 'framer-motion';
import AnimatedHeading from "../shared/AnimatedHeading";
import { Link } from 'react-router-dom';

const packages = [
  {
    title: "Basic Package",
    features: ["5-page responsive website", "Essential SEO", "Contact form integration"],
    price: "£250",
    popular: false
  },
  {
    title: "Standard Package",
    features: ["10-page website", "Custom design", "Blog integration", "E-commerce ready"],
    price: "£500",
    popular: true
  },
  {
    title: "Premium Package",
    features: ["Feature-rich website", "API integrations", "Payment gateways", "Advanced security"],
    price: "£1,000",
    popular: false
  }
];

const PackagesSection = () => {
  return (
    <section className="relative overflow-hidden py-24">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="/images/bg-images/packages-bg.jpeg" 
          alt="" 
          className="w-full h-full object-cover"
        />
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '32px 32px',
        }}></div>
      </div>

      {/* Animated Orbs with adjusted opacity */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full mix-blend-multiply filter blur-[128px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full mix-blend-multiply filter blur-[128px] animate-pulse delay-1000"></div>

      <div className="container mx-auto px-6 relative z-10">
        <AnimatedHeading text="Web Development Packages" className="text-white" />
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {packages.map((pkg, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              className={`relative bg-white/10 backdrop-blur-md p-8 rounded-2xl border border-white/10
                hover:border-white/20 transition-all duration-300 ${pkg.popular ? 'transform scale-105' : ''}`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-1 rounded-full text-sm font-medium">
                    Most Popular
                  </span>
                </div>
              )}
              <h3 className="text-2xl font-semibold mb-2 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                {pkg.title}
              </h3>
              <div className="text-3xl font-bold text-white mb-6">{pkg.price}</div>
              <ul className="space-y-4 mb-8">
                {pkg.features.map((feature, i) => (
                  <li key={i} className="flex items-center text-gray-300">
                    <svg className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <Link to="/services">
                <motion.button 
                  className={`w-full py-3 px-6 rounded-lg font-semibold transition-all duration-300
                    ${pkg.popular 
                      ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:shadow-lg hover:shadow-blue-500/25' 
                      : 'bg-white/10 text-white hover:bg-white/20'
                    }`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Get Started
                </motion.button>
              </Link>
              
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PackagesSection;